import { Box } from "@mui/material";
import React from "react";
import jwt from "jsonwebtoken";

export const getAgeRange = (token) => {
  if (!token) return null;
  try {
    const { ageRange } = jwt.decode(token);
    if (!ageRange) return 120;
    return ageRange;
  } catch (error) {
    return null;
  }
};

export const getAgeRangePublicRoute = () => {
  const token = localStorage.getItem("webTvUserToken");

  if (!token) return 120;
  try {
    const { ageRange } = jwt.decode(token);
    if (!ageRange) return 120;
    return ageRange;
  } catch (error) {
    return 120;
  }
};

const GetAgeRangeComponent = (ageRange = 0) => {
  switch (ageRange) {
    case 120:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/18.svg"}
            alt={"مناسب برای بالای 18 سال"}
            className={"w-[40px] "}
            mx={0.5}
          />
          <p className="font-bold">مناسب برای بالای ۱۸ سال</p>
        </div>
      );
    case 18:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/15.svg"}
            alt={"مناسب برای بالای 15 سال"}
            className={"w-[40px] "}
            mx={0.5}
          />

          <p className="font-bold">مناسب برای تا ۱۸ سال</p>
        </div>
      );
    case 13:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/12.svg"}
            alt={"مناسب برای بالای 12 سال"}
            className={"w-[40px] "}
            mx={0.5}
          />
          <p className="font-bold"> مناسب برای تا ۱۳ سال</p>
        </div>
      );
    case 7:
      return (
        <div className={"age-range inline-flex items-center"}>
          <Box
            component={"img"}
            src={"/images/age/6.svg"}
            mx={0.5}
            alt={"مناسب برای بالای 6 سال"}
            className={"w-[40px] "}
          />

          <p className="font-bold">مناسب برای زیر 7 سال</p>
        </div>
      );
    default:
      return null;
  }
};

export default GetAgeRangeComponent;
